export default "__VITE_ASSET__9IYD7Ndn__"